import Home from "@/views/home.vue";
import Works from "@/views/works.vue";
import Playground from "@/views/playground.vue";
import Bean from "@/views/works/mobile/single-work-bean.vue"
import Swift from "@/views/works/mobile/single-work-swift.vue"
import VitaminSea from "@/views/works/web/single-work-vitaminsea.vue"
import Diamond from "@/views/works/web/single-work-diamond.vue"
import Blink from "@/views/works/film/single-work-blink.vue"
import Dawn from "@/views/works/game/single-work-dawn.vue"
import Rusted from "@/views/works/game/single-work-rusted.vue"
// import Contact from "@/views/contact.vue";

const Routes = [
    {
        path: "/",
        component: Home,
        name: "home",
    },
    {
        path: "/works",
        component: Works,
        name: "works",
    },
    {
        path: "/works/bean",
        component: Bean,
        name: "bean",
    },
    {
        path: "/works/swift",
        component: Swift,
        name: "swift",
    },
    {
        path: "/works/vitaminsea",
        component: VitaminSea,
        name: "vitaminsea",
    },
    {
        path: "/works/diamond",
        component: Diamond,
        name: "diamond",
    },
    {
        path: "/works/blink",
        component: Blink,
        name: "blink",
    },
    {
        path: "/works/dawn",
        component: Dawn,
        name: "dawn",
    },
    {
        path: "/works/rusted",
        component: Rusted,
        name: "rusted",
    },
    {
        path: "/playground",
        component: Playground,
        name: "playground",
    },
];

export default Routes;
